import { EventEmitter } from '@angular/core';

const mobile: boolean = /iPhone|iPad|iPod|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent) || (navigator['userAgentData'] && navigator['userAgentData']['mobile']);

const onKeyboard = new EventEmitter<boolean>();


let last = { s: window.screen.height };

window.addEventListener('resize', () => {

  if (window.screen.height == last.s) {
    onKeyboard.emit(Device.keyboard);
  }

  last = { s: window.screen.height };
});

/** Provides device's related information*/
export class Device {

  /** Indicates whether application is running on a mobile device or not */
  public static get mobile(): boolean {
    return mobile;
  }

  public static get usable(): { width: number, height: number } {
    return { width: window.innerWidth, height: window.innerHeight };
  }

  public static get resolution(): { width: number, height: number } {
    return { width: window.screen.width, height: window.screen.height };
  }

  public static get keyboard() {
    return Device.mobile && window.outerHeight / window.screen.height < 0.8;
  }

  public static get onKeyboard() {
    return onKeyboard;
  }

  private constructor() {
  }
}

